// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"aadde68b","732":"0862b2da","977":"6b016115"}[chunkId] + ".chunk.js";
};